import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

import
{
  TenantFrontendApi_GetTenant,
  TenantFrontendApi_UpdateTenant
} from "./TenantFrontendApi";

import { Translate } from "./Translator";
import Header from "./Header";
import MainMenu from "./MainMenu";
import Footer from "./Footer";
import BlueBar from "./BlueBar";

import HomeLogo from "./Assets/HomeLogo.png";

import './Tenant.css';
import './EditUser.css';
import './EditTenant.css';

function EditTenant() {
  const navigate = useNavigate();

  const [mRepaint, SetRepaint] = useState(false);
  const [mTenant, SetTenant] = useState(null);
  const [mTenantGuid, SetTenantGuid] = useState();
  const [mCanNotMakeResellerTenant, SetCanNotMakeResellerTenant] = useState("");
  const [mShowCanNotSetDemoTenant, SetShowCanNotSetDemoTenant] = useState(false);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    let isMounted = true;  // Track if component is mounted
  
    setIsClient(true);
  
    async function GetTenant(guid) {
      try {
        const response = await TenantFrontendApi_GetTenant(sessionStorage.getItem("token"), guid);
        if (isMounted) SetTenant(response.data); // Update only if mounted
      } catch (ex) {
        handleApiError(ex, "tenant");
      }
    }
  
    function handleApiError(ex, type) {
      let errorCode = null;
      try {
        if (ex.response && ex.response.status) {
          errorCode = ex.response.status;
        }
        navigate(`../error?errorcode=${errorCode}&error=${type}`);
      } catch {}
      console.log("Error: ", ex);
    }
  
    const urlParams = new URLSearchParams(window.location.search);
    const tenantGuid = urlParams.get('tenantguid');
    SetTenantGuid(tenantGuid);
  
    GetTenant(tenantGuid);

    return () => {
      isMounted = false;  // Cleanup on unmount
    };
  }, [navigate]);
  
  useEffect(() => {
    setIsClient((prevState) => ({
      ...prevState, 
      SuperTenantManageTenants: mTenant?.SuperTenantManageTenants || false,
      AllowIncreaseDecreaseLicenses: mTenant?.AllowIncreaseDecreaseLicenses || false,  // Set this based on your tenant data
    }));
  }, [mTenant]); // Runs when `mTenant` changes
  

  const SetName = (val) => { mTenant.Company = val; SetRepaint(!mRepaint); };
  const SetAddress1 = (val) => { mTenant.CompanyAddressLine1 = val; SetRepaint(!mRepaint); };
  const SetAddress2 = (val) => { mTenant.CompanyAddressLine2 = val; SetRepaint(!mRepaint); };
  const SetTenantApiSetting = (val) => { mTenant.ApiSettings = val; SetRepaint(!mRepaint); };
  const SetPostalCode = (val) => { mTenant.CompanyPostalCode = val; SetRepaint(!mRepaint); };
  const SetCity = (val) => { mTenant.CompanyCity = val; SetRepaint(!mRepaint); };
  const SetCountry = (val) => { mTenant.CompanyCountry = val; SetRepaint(!mRepaint); };
  const SetPhone = (val) => { mTenant.CompanyPhone = val; SetRepaint(!mRepaint); };
  const SetVATNumber = (val) => { mTenant.VATNumber = val; SetRepaint(!mRepaint); };
 
 

  async function UpdateTenant() {
    try {
      const response = await TenantFrontendApi_UpdateTenant(
        sessionStorage.getItem("token"),
        mTenantGuid,
        mTenant.Company,
        mTenant.CompanyAddressLine1,
        mTenant.CompanyAddressLine2,
        mTenant.CompanyPostalCode,
        mTenant.CompanyCity,
        mTenant.CompanyCountry,
        mTenant.CompanyPhone,
        mTenant.VATNumber,
        mTenant.ApiSettings,
        mTenant.CustomId,
        mTenant.IsSuperTenant,
        mTenant.SuperTenantManageTenants,
        mTenant.SuperTenantManageLicences
      );
      console.log(JSON.stringify(response));
      navigate(`../tenant?tenantguid=${mTenantGuid}`);
    } catch (ex) {
      console.log("Error: ", ex?.response?.data?.Exception || ex);
    }
  }

  function UpdateInformation()
  {
    UpdateTenant();
  }

  function languageChanged() {
    SetRepaint(!mRepaint);
  }

  if (!isClient || !mTenant) {
    return <div>Loading tenant data...</div>;
  }

  return (
    <span>
      <Header onLanguageChanged={languageChanged} />
      <MainMenu MainMenuNumber={2} />

      <table width="1200" cellPadding={0} cellSpacing={0} align="center">
                <tbody>                
                    <tr className="pagetop3">
                        <td height="75" valign="bottom">
                            <table width="100%" cellPadding={0} cellSpacing={0} className="down10px">
                                <tbody>
                                    <tr height="60">
                                        <td
                                            width="100%"
                                            align="left"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                flexWrap: 'nowrap'
                                            }}
                                        >
                                        {/* Home Logo */}
                                        <a
                                            href="/"
                                            onClick={(e) => {
                                                if (!e.ctrlKey && !e.metaKey && e.button === 0) {
                                                    e.preventDefault();
                                                    navigate("/");
                                                }
                                            }}
                                            title="Home"
                                        >
                                            <img
                                                alt="Home logo"
                                                className="HomeLogo pointer"
                                                src={HomeLogo}
                                                style={{ cursor: "pointer" }}
                                        />
                                        </a>     
                                          {/* Company */}
                                          <a
                                              href={`../tenant?tenantguid=${mTenantGuid}`}
                                              onClick={(e) => {
                                                  if (!e.ctrlKey && !e.metaKey && e.button === 0) {
                                                      e.preventDefault();
                                                      navigate(`../tenant?tenantguid=${mTenantGuid}`);
                                                  }
                                              }}
                                              className="black bold pointer underline paddingright10"
                                              style={{ textDecoration: "underline", cursor: "pointer" }}
                                          >
                                              {mTenant.Company}
                                          </a>

                                          {/* Separator */}
                                          <span className="blue">/</span>

                                          {/* Edit (non-clickable) */}
                                          <span className="bold">{Translate("Edit")}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>

                    <tr height="20"/>

                    
                    <tr>
                        <td className="bold fontsize30 width100 width30">{Translate("Edit tenant")}</td>
                        <td></td>
                    </tr>

                    <tr height="10"/>

                    <tr>
                        <td className="width30">
                            <BlueBar/>
                        </td>
                    </tr>           

                    <tr height="20"/>

                </tbody>
            </table>

            {/* Edit a specific tenant */}
            <table className="usermainsettingtable" width="1200" cellPadding={0} cellSpacing={0} align="center">
            <tbody>
                <tr height="20" />

                <tr>
                <td width="40" />
                <td className="bold fontsizelarge">{Translate("Information")}</td>
                <td />
                </tr>

                <tr height="20" />

                {/* Company Name */}
                <tr>
                <td width="40" />
                <td className="bold fontsizesmall">{Translate("Company name")}</td>
                </tr>

                <tr height="10" />

                <tr height="40">
                <td width="40" />
                <td width="1000">
                    <input
                    value={mTenant?.Company || ""}
                    onChange={(e) => SetName(e.target.value)}
                    className="inputtd"
                    />
                </td>
                <td />
                </tr>

                <tr height="20" />

                {/* Address */}
                {
                [
                { label: "Address 1", key: "CompanyAddressLine1", setter: SetAddress1 },
                { label: "Address 2", key: "CompanyAddressLine2", setter: SetAddress2 },
                { label: "Postal code", key: "CompanyPostalCode", setter: SetPostalCode },
                { label: "City", key: "CompanyCity", setter: SetCity },
                { label: "Country", key: "CompanyCountry", setter: SetCountry },
                { label: "Phone", key: "CompanyPhone", setter: SetPhone },
                { label: "VAT number", key: "VATNumber", setter: SetVATNumber },
                ].map(({ label, key, setter }) => (
                <React.Fragment key={key}>
                    <tr>
                    <td width="40" />
                    <td className="bold fontsizesmall">{Translate(label)}</td>
                    </tr>
                    <tr height="10" />
                    <tr height="40">
                    <td width="40" />
                    <td width="1000">
                        <input
                        value={mTenant?.[key] || ""}
                        onChange={(e) => setter(e.target.value)}
                        className="inputtd"
                        />
                    </td>
                    <td />
                    </tr>
                    <tr height="20" />
                </React.Fragment>
                ))}

                {/* Tenant API Settings */}
                <tr>
                <td width="40" />
                <td className="bold fontsizesmall">{Translate("Tenant API settings")}</td>
                </tr>

                <tr height="10" />

                <tr height="80">
                <td width="40" />
                <td>
                    <textarea
                    value={mTenant?.ApiSettings || ""}
                    onChange={(e) => SetTenantApiSetting(e.target.value)}
                    className="textareaedittenat"
                    />
                </td>
                <td />
                </tr>

                <tr height="20"/>

                {/* Update Button */}
                <tr>
                    <td width="40" />
                    <td className="bold fontsizesmall">
                        <button className="saveusersettingsbutton bold" onClick={UpdateInformation}>
                        {Translate("Update information")}
                        </button>
                    </td>
                </tr>

                <tr height="20" />
            </tbody>
            </table>

            
            {/*Footer Table*/}
            <table>
                <tbody>
                    <tr height="60"></tr>
                </tbody>
            </table>

      <Footer />

      {/* Modals */} {/* Managing reseller tenant privilege */}
      <Modal animation={false} style={{ opacity: 1 }} show={mCanNotMakeResellerTenant !== ""} onHide={() => SetCanNotMakeResellerTenant("")} centered>
        <Modal.Header closeButton>
          <Modal.Title align="center">
            <span>This tenant is part of another tenant, so it cannot be made a reseller tenant.</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer align="center">
          <Button variant="dark" onClick={() => SetCanNotMakeResellerTenant("")}>{Translate("Ok")}</Button>
        </Modal.Footer>
      </Modal>
      
      {/* Managing tenant demo accounts */}
      <Modal animation={false} style={{ opacity: 1 }} show={mShowCanNotSetDemoTenant} onHide={() => SetShowCanNotSetDemoTenant(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title align="center">
            <span>{mShowCanNotSetDemoTenant}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer align="center">
          <Button variant="dark" onClick={() => SetShowCanNotSetDemoTenant(false)}>{Translate("Ok")}</Button>
        </Modal.Footer>
      </Modal>
    </span>
  );
}

export default EditTenant;
